import * as React from "react";
import type { SupportedLocale } from "../i18n";

type Props = {
  locale: SupportedLocale;
  size?: number;
  title?: string;
};

/** Compact SVG country flags for supported locales (reliable on Windows). */
export function CountryFlag({ locale, size = 20, title }: Props) {
  const common = {
    width: size,
    height: size * 0.75,
    viewBox: "0 0 16 12",
    role: "img" as const,
    "aria-hidden": title ? undefined : true,
    style: { display: "block", borderRadius: 2, boxShadow: "0 0 0 1px rgba(0,0,0,0.12)" },
  };

  switch (locale) {
    case "en-US":
      return (
        <svg {...common} aria-label={title}>
          {title ? <title>{title}</title> : null}
          <rect width="16" height="12" fill="#B22234" />
          <path
            d="M0 1.385h16M0 3.692h16M0 6h16M0 8.308h16M0 10.615h16"
            stroke="#fff"
            strokeWidth="1.385"
          />
          <rect width="6.4" height="6.46" fill="#3C3B6E" />
        </svg>
      );
    case "es-MX":
      return (
        <svg {...common} aria-label={title}>
          {title ? <title>{title}</title> : null}
          <rect width="16" height="12" fill="#fff" />
          <rect width="5.33" height="12" fill="#006847" />
          <rect x="10.67" width="5.33" height="12" fill="#CE1126" />
          <circle cx="8" cy="6" r="1.4" fill="#B8860B" />
        </svg>
      );
    case "fr-FR":
      return (
        <svg {...common} aria-label={title}>
          {title ? <title>{title}</title> : null}
          <rect width="16" height="12" fill="#fff" />
          <rect width="5.33" height="12" fill="#002395" />
          <rect x="10.67" width="5.33" height="12" fill="#ED2939" />
        </svg>
      );
    case "de-DE":
      return (
        <svg {...common} aria-label={title}>
          {title ? <title>{title}</title> : null}
          <rect width="16" height="4" fill="#000" />
          <rect y="4" width="16" height="4" fill="#D00" />
          <rect y="8" width="16" height="4" fill="#FFCE00" />
        </svg>
      );
  }
}
